import React, { useEffect, useState } from "react";
import { renderRoutes, RouteConfig } from "react-router-config";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import packageJson from "../package.json";
import "./App.css";
import { SiteDataProvider } from "./SiteDataProvider";
import { Wrapper } from "./styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"; // Import QueryClient
import { fetchRoutes } from "./routes";
import { HelmetProvider } from "react-helmet-async";
import GlobalClickListener from "./tracking/GlobalClickListener";

const eshopComponentLibPackage = packageJson.dependencies["one-ui-library"];

// Create the QueryClient instance outside the component
const queryClient = new QueryClient();

const App: React.FC = () => {
  const location = useLocation();
  const helmetContext = {};

  const [routes, setRoutes] = useState<RouteConfig[]>([]);

  useEffect(() => {
    // Fetch dynamic routes and set them in state
    const loadRoutes = async () => {
      const fetchedRoutes = await fetchRoutes();
      setRoutes(fetchedRoutes);
    };

    loadRoutes();
    console.warn("CICD WORKING");
    console.warn(`Env ========== ${process.env.NODE_ENV}`);
  }, []);

  return (
    <>
      <HelmetProvider context={helmetContext}>
        <QueryClientProvider client={queryClient}>
          <SiteDataProvider
            slug={location.pathname === "/" ? "home" : location.pathname}
          >
            <Wrapper
              data-component-library-package={eshopComponentLibPackage}
              className={true ? "styledWrapper sidebarOpen" : "styledWrapper"}
            >
              {renderRoutes(routes)}
            </Wrapper>
            <GlobalClickListener />
          </SiteDataProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </>
  );
};

export default App;
